import { SimpleGrid, Skeleton } from 'components'
import type { GridSkeletonProps } from '../interfaces'
import { GRID_BREAKPOINTS, GRID_COLS, LATEST_LIMIT, SKELETON_HEIGHT } from '../constants'

/** First-load placeholder shown while a dashboard section is fetching. */
export const GridSkeleton = ({ count = LATEST_LIMIT, height = SKELETON_HEIGHT }: GridSkeletonProps) => {
  return (
    <SimpleGrid cols={GRID_COLS} spacing='md' breakpoints={GRID_BREAKPOINTS}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton key={index} height={height} radius='md' />
      ))}
    </SimpleGrid>
  )
}
